import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSingleInsightStart,
  selectInsightById,
} from "../features/insights";
import { InsightTooltip } from "./InsightTooltip";

interface MultiInsightTooltipContentProps {
  insightIds: string[];
  showDocumentLink?: boolean;
}

export const MultiInsightTooltipContent: React.FC<
  MultiInsightTooltipContentProps
> = ({ insightIds, showDocumentLink = true }) => {
  const dispatch = useDispatch();
  const insights = insightIds.map((id) => useSelector(selectInsightById(id)));

  useEffect(() => {
    insightIds.forEach((id, index) => {
      if (!insights[index]) {
        dispatch(fetchSingleInsightStart(id));
      }
    });
  }, [dispatch, insightIds, insights]);

  return (
    <Box>
      {insights.map((insight, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            mb: index < insightIds.length - 1 ? 1.5 : 0,
          }}
        >
          <Box>
            <InsightTooltip
              insightId={insight?.id || ""}
              showDocumentLink={showDocumentLink}
            />
          </Box>
          <Typography
            variant="caption"
            sx={{
              ml: 1,
              color: "text.secondary",
              maxWidth: 200,
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {insight?.description || "Loading..."}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
